import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {formatCurrency} from "@angular/common";
import {DataFormatService} from "../../../services/data-format.service";
import { Apollo } from 'apollo-angular';
import { ApiService } from 'src/app/api/api.service';
import {update_tax_credits} from "./graphql/updateTaxCredits";
import {MatSnackBar, MatSnackBarConfig} from "@angular/material/snack-bar";
import moment from 'moment';
import { UserPermissionsService } from 'src/app/services/user-permissions.service';
const UPDATE_TAX_CREDITS = update_tax_credits;

@Component({
    selector: 'deal-tax-credits',
    templateUrl: './tax-credits.component.html',
    styleUrls: ['./tax-credits.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TaxCreditsComponent {
  @Input() projectCredits: any;
  @Input() projectid: any;
  @Input() taxCreditTypes: any;
  @Input() taxCreditDesignations: any;
  @Input() projectCreditStatuses: any;
  credits: any = [];
  creditsToDelete: any[] = [];
  creditsEdit: any[];
  editingCredits: boolean = false;
  constructor(private dataFormat: DataFormatService, private apiService: ApiService,
    private apollo: Apollo, private _snackBar: MatSnackBar,  public permsService: UserPermissionsService) {}

  ngOnInit(): void {
    this.permsService.getUserPermissions('PROJECTDETAIL', null);
    this.credits = this.formatProjectCredits(this.projectCredits);
    this.creditsEdit = this.formatProjectCreditsForEdit(this.projectCredits);
  }

  editTaxCreditsButton() {
    if(!this.editingCredits) {
      this.editingCredits = true;
    } else {
      this.editingCredits = false;
    }
  }

  addTaxCreditsButton() {
    this.creditsEdit.push({
      id: null,
      amount: 0,
      equity_amount: 0,
      price: 0,
      tax_credit_type_id: null,
      tax_credit_designation_id: null,
      certificated: false,
      crea_syndicated: true,
      tax_credit_type: null,
    });
  }

  deleteCredit(i: any) {
    if(this.creditsEdit[i].id) {
    } else {
      return;
    }

    this.apollo
    .mutate({
      mutation: UPDATE_TAX_CREDITS,
      variables: {
        input: {
          id: this.projectid,
          projectCredits: {
            upsert: [],
            delete: [this.creditsEdit[i].id]
          }
        },
      },
    })
    .subscribe(
      ({ data }) => {
        this.openSnackBar("Tax credit deleted.");
        this.credits = this.formatProjectCredits((data as any).updateProjectCredits.projectCredits);
      }
    );
    this.creditsEdit.splice(i,1);
  }

  changeCreditType(credit: any) {
    if(credit.tax_credit_type) {
      credit.name = credit.tax_credit_type.level + " " + credit.tax_credit_type.name;
      credit.tax_credit_type_id = credit.tax_credit_type.id;
      credit.tax_credit_designation_id = null;
    } else {
      credit.name = null;
      credit.tax_credit_type_id = null;
      credit.tax_credit_designation_id = null;
    }
  }

  openSnackBar(message: string) {
    const config = new MatSnackBarConfig();
    config.panelClass = ['save-success'];
    config.horizontalPosition = "center";
    config.verticalPosition = "top";
    config.duration = 3000;
    this._snackBar.open(message, 'Ok', config);
  }

  failSnackBar(message: string) {
    const config = new MatSnackBarConfig();
    config.panelClass = ['save-fail'];
    config.horizontalPosition = "center";
    config.verticalPosition = "top";
    config.duration = 3000;
    this._snackBar.open(message, 'Ok', config);
  }

  saveTaxCreditsButton() {

    //verify new credits have a credit type and designation
    let setType = true;
    let setDesignation = true;
    let setStatus = true;
    for(let i = 0; i < this.creditsEdit.length; i += 1) {

      if(this.creditsEdit[i].id) {
      } else {
        if(this.creditsEdit[i].tax_credit_type_id === null) {
          setType = false;
          break;
        } else {
          if(this.creditsEdit[i].name && this.creditsEdit[i].name === "Federal LIHTC") {
            if(this.creditsEdit[i].tax_credit_designation_id === null) {
              setDesignation = false;
              break;
            }
          }
        }
      }
    }

    if(setType === false) {
      //Some fields aren't filled out. Show a failure snackbar.
      this.failSnackBar("Could not save Tax Credits. Please fill out all Credit Types.");
      return;
    }
    if(setDesignation === false) {
      //Some fields aren't filled out. Show a failure snackbar.
      this.failSnackBar("Could not save Tax Credits. Please fill out all Credit Designations.");
      return;
    }



    this.editingCredits = false;

   let toSend: any[] = [];

    for(let i = 0; i < this.creditsEdit.length; i += 1) {
      toSend.push(
        {
          id: this.creditsEdit[i].id,
          amount: this.creditsEdit[i].amount,
          equity_amount: this.creditsEdit[i].equity_amount,
          price: this.creditsEdit[i].price,
          tax_credit_type_id: this.creditsEdit[i].tax_credit_type_id,
          tax_credit_designation_id: this.creditsEdit[i].tax_credit_designation_id,
          project_credit_status_id: this.creditsEdit[i]['projectCreditStatus'] ? this.creditsEdit[i]['projectCreditStatus'].id : null,
          certificated: this.creditsEdit[i].certificated ? 1 : 0,
          crea_syndicated: this.creditsEdit[i].crea_syndicated ? 1 : 0,
        }
      );
    }

    this.apollo
    .mutate({
      mutation: UPDATE_TAX_CREDITS,
      variables: {
        input: {
          id: this.projectid,
          projectCredits: {
            upsert: toSend,
            delete: []
          }
        },
      },
    })
    .subscribe(
      ({ data }) => {
        this.openSnackBar("Tax Credits saved successfully.");
        this.credits = this.formatProjectCredits((data as any).updateProjectCredits.projectCredits);
        this.creditsEdit = this.formatProjectCreditsForEdit((data as any).updateProjectCredits.projectCredits);
      }
    );
  }

  formatProjectCreditsForEdit(credits: any) {
    this.creditsEdit = [];
    let federal: any = [];
    let state: any = [];
    let nonsyn: any = [];
    for(let i = 0; i < credits.length; i++){
      let name: string = credits[i]['taxCreditType']['level'] + " " + credits[i]['taxCreditType']['name'];
      if(credits[i]['taxCreditDesignation']){
        name += " - " + credits[i]['taxCreditDesignation']['name'];
      }

      let tableobj = JSON.parse(JSON.stringify(credits[i]));

        tableobj.name = name;
        tableobj.tax_credit_type_id = credits[i]['taxCreditType'].id;
        tableobj.crea_syndicated = credits[i]['crea_syndicated'];
        tableobj.tax_credit_designation_id = credits[i]['taxCreditDesignation'] ? credits[i]['taxCreditDesignation'].id : null;
        tableobj.table = [
          {field: "Total Credits", value: formatCurrency(credits[i]['amount'], 'EN', '$', 'USD', '1.0-0')},
          {field: "Price Per Credit", value: formatCurrency(credits[i]['price'], 'EN', '$', 'USD', '1.4-4')},
          {field: "Lower Tier Equity", value: formatCurrency(credits[i]['equity_amount'], 'EN', '$', 'USD', '1.0-0')},
          {field: "Credit Status", value: credits[i]['projectCreditStatus'] ? credits[i]['projectCreditStatus']['name'] : 'N/A'},
          {field: "Certificated", value: this.dataFormat.yesNoFormat(credits[i]['certificated'])},
          {field: "CREA Syndicated", value: this.dataFormat.yesNoFormat(credits[i]['crea_syndicated'])}
        ];


      !credits[i]["crea_syndicated"] ? nonsyn.push(tableobj) : credits[i]['taxCreditType']['level'] === 'Federal' ? federal.push(tableobj) : state.push(tableobj);
    }

    federal = this.creditSort(federal);
    state = this.creditSort(state);
    nonsyn = this.creditSort(nonsyn);
    return federal.concat(state).concat(nonsyn);
  }

  formatProjectCredits(credits: any) {
    let federal: any = [];
    let state: any = [];
    let nonsyn: any = [];
    for(let i = 0; i < credits.length; i++){
      let name: string = credits[i]['taxCreditType']['level'] + " " + credits[i]['taxCreditType']['name'];
      if(credits[i]['taxCreditDesignation']){
        name += " - " + credits[i]['taxCreditDesignation']['name'];
      }

      let tableobj = {
        name: name,
        crea_syndicated: credits[i]['crea_syndicated'],
        table: [
          {field: "Total Credits", value: formatCurrency(Math.trunc(credits[i]['amount']), 'EN', '$', 'USD', '1.0-0')},
          {field: "Price Per Credit", value: formatCurrency(credits[i]['price'], 'EN', '$', 'USD', '1.4-4')},
          {field: "Lower Tier Equity", value: formatCurrency(Math.trunc(credits[i]['equity_amount']), 'EN', '$', 'USD', '1.0-0')},
          {field: "Credit Status", value: credits[i]['projectCreditStatus'] ? credits[i]['projectCreditStatus']['name'] : 'N/A'},
          {field: "Certificated", value: this.dataFormat.yesNoFormat(credits[i]['certificated'])},
          {field: "CREA Syndicated", value: this.dataFormat.yesNoFormat(credits[i]['crea_syndicated'])}
        ]
      };


      !credits[i]["crea_syndicated"] ? nonsyn.push(tableobj) : credits[i]['taxCreditType']['level'] === 'Federal' ? federal.push(tableobj) : state.push(tableobj);
    }

    federal = this.creditSort(federal);
    state = this.creditSort(state);
    return federal.concat(state).concat(nonsyn);
  }

  //This is to sort the tax credits so LIHTC is first
  //then is listed alphabetically
  creditSort(credits: any): any {

    //Sort Credits alphabetically first
    function compare( a:any, b:any ) {
      if ( a.name < b.name ){
        return -1;
      }
      if ( a.name > b.name ){
        return 1;
      }
      return 0;
    }
    credits.sort( compare );

    //Find LIHTC credits and put them at beginning
    //of array
    let lihtc4 = null;
    let lihtc9 = null;
    for(let i = 0; i < credits.length; i++){
      if(credits[i].name.includes('LIHTC - 4%')){
        lihtc4 = i;
      } else if(credits[i].name.includes('LIHTC - 9%')){
        lihtc9 = i;
      }
    }
    if(lihtc9){
      credits = this.array_move(credits, lihtc9, 0);
    }
    if(lihtc4){
      credits = this.array_move(credits, lihtc4, 0);
    }
    return credits;
  }

  //this is to move objects within an array
  array_move(arr: any, old_index: number, new_index: number) {
    if (new_index >= arr.length) {
      var k = new_index - arr.length + 1;
      while (k--) {
        arr.push(undefined);
      }
    }
    arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
    return arr;
  };
}
